/* vl-addons — the "Birlikte alın" rows OUTSIDE <vl-main-product> (today: the Sitting Cushion landing, sections/vl-lx-hero.liquid).
   The same rows inside the product section are handled by assets/vl-main-product.js (addonToggle…); this script skips those.
   A tick puts the row's product into the cart at once with the hidden property _vl_addon_for = the page's product (data-for on
   the box), the bed row adds the bed's cheapest size with its gift pillow line (data-gift-*), an untick takes that line out, the
   rows follow the cart on load and on every cart:update / cart:reload / cart:refresh. Owner, 2026-10-17: "you don't give
   suggestions in sitting cushion". */
(function () {
  'use strict';
  if (window.vlAddonsInit) return;
  window.vlAddonsInit = true;
  var boxes = function () { return Array.prototype.slice.call(document.querySelectorAll('[data-vl-addons]')).filter(function (b) { return !b.closest('vl-main-product'); }); };
  var post = function (url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); });
  };
  var cartJson = function () { return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }); };
  var lines = function (row, forHandle) {
    var id = parseInt(row.getAttribute('data-variant'), 10); if (!id) return [];
    var items = [{ id: id, quantity: 1, properties: { _vl_addon_for: forHandle } }];
    var gv = parseInt(row.getAttribute('data-gift-variant'), 10), per = parseInt(row.getAttribute('data-gift-per'), 10) || 0;
    if (gv && per) {
      var props = {}, prop = row.getAttribute('data-gift-prop'), val = row.getAttribute('data-gift-value');
      if (prop && val) props[prop] = val;
      props._vl_gift_for = String(id); props._vl_gift_per = String(per);
      items.push({ id: gv, quantity: per, properties: props });
    }
    return items;
  };
  var add = function (row, forHandle) {
    var items = lines(row, forHandle); if (!items.length) return Promise.reject(0);
    return post('/cart/add.js', { items: items }).catch(function () { if (items.length > 1) return post('/cart/add.js', { items: items.slice(0, 1) }); throw 0; });
  };
  var remove = function (row, forHandle) {
    var id = String(row.getAttribute('data-variant'));
    return cartJson().then(function (cart) {
      var line = (cart.items || []).filter(function (it) { return String(it.variant_id) === id && it.properties && it.properties._vl_addon_for === forHandle; })[0];
      if (!line) return null;
      return post('/cart/change.js', { id: line.key, quantity: 0 });
    });
  };
  var toast = function () { var t = document.querySelector('.vl-lx-toast, .vl-mp-toast'); if (t) { t.classList.add('show'); setTimeout(function () { t.classList.remove('show'); }, 2400); } };
  var changed = function (on) {
    if (on) toast();
    cartJson().then(function (c) {
      document.querySelectorAll('hdt-cart-count, .cart-count, .cart-count-bubble span, [data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
      document.dispatchEvent(new CustomEvent('cart:count:update', { detail: { item_count: c.item_count } }));
    }).catch(function () {});
    try { document.dispatchEvent(new CustomEvent('cart:reload')); } catch (e) {}
  };
  var toggle = function (box, row, cb) {
    var forHandle = box.getAttribute('data-for') || '', on = cb.checked, handle = row.getAttribute('data-handle') || '';
    if (row.getAttribute('data-busy') === '1') { cb.checked = !on; return; }
    row.setAttribute('data-busy', '1'); cb.disabled = true; row.classList.toggle('is-on', on);
    (on ? add(row, forHandle) : remove(row, forHandle)).then(function () {
      row.removeAttribute('data-busy'); cb.disabled = false;
      if (on) { try { if (window.vlTrack) window.vlTrack.send('addon_add', { handle: handle }); } catch (e) {} }
      changed(on);
    }).catch(function () {
      row.removeAttribute('data-busy'); cb.disabled = false; cb.checked = !on; row.classList.toggle('is-on', !on);
    });
  };
  var syncing = false;
  var sync = function () {
    var bs = boxes(); if (!bs.length || syncing) return; syncing = true;
    cartJson().then(function (cart) {
      /* the header count follows the cart too (an unticked bed loses its gift pillow a moment later, announced by vl-gift.js with cart:reload) */
      document.querySelectorAll('hdt-cart-count, .cart-count, .cart-count-bubble span, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      bs.forEach(function (box) {
        var forHandle = box.getAttribute('data-for') || '', inCart = {};
        (cart.items || []).forEach(function (it) { if (it.properties && it.properties._vl_addon_for === forHandle) inCart[String(it.variant_id)] = 1; });
        box.querySelectorAll('[data-vl-addon]').forEach(function (row) {
          var cb = row.querySelector('input[type="checkbox"]'); if (!cb || row.getAttribute('data-busy') === '1') return;
          var on = !!inCart[row.getAttribute('data-variant')]; cb.checked = on; row.classList.toggle('is-on', on);
        });
      });
      syncing = false;
    }).catch(function () { syncing = false; });
  };
  var bind = function () {
    boxes().forEach(function (box) {
      if (box.getAttribute('data-bound') === '1') return;
      box.setAttribute('data-bound', '1');
      box.querySelectorAll('[data-vl-addon]').forEach(function (row) {
        var cb = row.querySelector('input[type="checkbox"]'); if (cb) cb.addEventListener('change', function () { toggle(box, row, cb); });
      });
    });
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  ['cart:update', 'cart:reload', 'cart:refresh'].forEach(function (ev) { document.addEventListener(ev, function () { sync(); }); });
  document.addEventListener('shopify:section:load', bind);
})();
